import { useEffect, useMemo } from "react";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";

const useGlobalTable = (columns = [], data = [], isModal = false) => {
  // Ensure columns and data are at least arrays
  const safeColumns = Array.isArray(columns) ? columns : [];
  const safeData = Array.isArray(data) ? data : [];

  const currentPageName =
    window.location.hash.split("/crm/")[1]?.split("/")[0] || "defaultPage";
  const urlParts = window.location.hash.split("/crm/")[1]?.split("/") || [];
  const hasSubPath = urlParts.length > 1;
  const savedState = JSON.parse(localStorage.getItem("paginationState")) || {};
  const savedSearchTerm = localStorage.getItem("searchTerm") || "";

  const initialPageIndex =
    savedState?.pageName === currentPageName &&
      savedState?.pageIndex !== undefined &&
      !isModal
      ? savedState.pageIndex
      : 0;

  const initialPageSize =
    savedState?.pageName === currentPageName &&
      savedState?.pageSize !== undefined &&
      !isModal
      ? savedState.pageSize
      : 10;

  const initialState = useMemo(
    () => ({
      pageIndex: initialPageIndex,
      pageSize: initialPageSize,
      globalFilter: savedSearchTerm,
    }),
    [initialPageIndex, initialPageSize, savedSearchTerm]
  );

  const tableInstance = useTable(
    {
      columns: safeColumns,
      data: safeData,
      initialState,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance;

  useEffect(() => {
    if (hasSubPath) {
      gotoPage(0);
    }
  }, [hasSubPath, gotoPage]);

  return {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    pageIndex,
    pageSize,
    globalFilter,
  };
};

export default useGlobalTable;
